import { useParams, Link } from "react-router-dom";
import { ArrowLeft, Printer } from "lucide-react";
import { useApi, track } from "@/lib/api";
import { useSeo } from "@/lib/site";
import { Loading, NotFoundBlock } from "@/components/site/Loading";
import { LogoSymbol } from "@/components/brand/Logo";

export default function ToolPage() {
  const { slug } = useParams();
  const { data: t, loading, error } = useApi(`/tools/${slug}`);
  useSeo(t?.title, t?.description);
  if (loading) return <Loading />;
  if (error || !t) return <NotFoundBlock title="We couldn't find that worksheet." />;
  const print = () => {
    track("tool_print", slug);
    window.print();
  };
  return (
    <div className="container-site pt-10" data-testid="tool-page">
      <div className="no-print flex flex-wrap items-center justify-between gap-4">
        <Link to="/direction" className="btn-ghost text-sm" data-testid="tool-back-link"><ArrowLeft className="h-4 w-4" aria-hidden="true" /> Direction</Link>
        <button type="button" onClick={print} className="btn-primary" data-testid="tool-print-button"><Printer className="h-5 w-5" aria-hidden="true" /> Print or save as PDF</button>
      </div>
      <article className="print-area card-soft !bg-white mt-8 p-6 sm:p-10 lg:p-14 max-w-4xl">
        <div className="flex items-center gap-3 text-sm text-ink-muted"><LogoSymbol size={28} /> Addiction &amp; Us · Practical tools</div>
        <h1 className="mt-6 text-4xl sm:text-5xl" data-testid="tool-title">{t.title}</h1>
        <p className="mt-4 text-lg text-ink-soft max-w-2xl">{t.intro}</p>
        {t.sections.map((s) => (
          <section key={s.heading} className="mt-10">
            <h2 className="text-2xl mb-4">{s.heading}</h2>
            {s.checklist ? (
              <ul className="space-y-3">
                {s.prompts.map((p) => <li key={p}><label className="flex items-start gap-3"><input type="checkbox" className="mt-1 h-5 w-5 accent-[#2F6B6A]" />{p}</label></li>)}
              </ul>
            ) : (
              <div className="space-y-6">
                {s.prompts.map((p) => (
                  <div key={p}>
                    <p className="font-medium">{p}</p>
                    <div className="print-lines mt-3 border-b border-dashed border-ink/20 h-10" />
                    <div className="print-lines border-b border-dashed border-ink/20 h-10" />
                  </div>
                ))}
              </div>
            )}
          </section>
        ))}
        <p className="mt-12 text-sm text-ink-muted">This worksheet is for your own use. Nothing you write here is sent to Addiction &amp; Us. In an emergency call 999. Samaritans: 116 123 (free, 24 hours).</p>
      </article>
    </div>
  );
}
